import { HttpClient } from "../HttpClient";

/**
 * * Update Application Status
 * @param {number} id - Application ID
 * @param {string} status - New status (e.g., "Pending", "Approved", "Rejected")
 */
export const UpdateApplicationStatus = async (id, status) => {
  try {
    const formData = new FormData();
    formData.append("Status", status);

    const { data } = await HttpClient.put(`api/application/${id}`, formData);
    return data;
  } catch (err) {
    console.error("Error updating application status:", err);
    return null;
  }
};
